
// SVG Icon: selected
export default { id: "terriajs-selected" };
export const id = "terriajs-selected";
export const name = "selected";
